// extracted by mini-css-extract-plugin
export var articlePage = "product-slider-module--article-page--9caf9";
export var bar = "product-slider-module--bar--bb349";
export var categoryTitle = "product-slider-module--category-title--23e90";
export var col = "product-slider-module--col--dac38";
export var grid_col_3 = "product-slider-module--grid_col_3--27175";
export var h2 = "product-slider-module--h2--e6afd";
export var productCard = "product-slider-module--product-card--fe06c";
export var reccomendedProducts = "product-slider-module--reccomendedProducts--ef6bb";
export var slickDots = "product-slider-module--slick-dots--6f754";
export var slickSlider = "product-slider-module--slick-slider--1c179";